import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {ClaimsService} from "../../../../services/claims.service";
import {TextInputComponent} from "../../../common/text-input/text-input.component";
import {format, parseISO, set} from "date-fns";
import {FormsModule} from "@angular/forms";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';

@Component({
  selector: 'app-accident-location',
  imports: [
    FooterComponent,
    HeaderComponent,
    TextInputComponent,
    FormsModule
  ],
  templateUrl: './accident-location.component.html',
  styleUrl: './accident-location.component.css'
})
export class AccidentLocationComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  street: string | null = null;
  houseNumber: string | null = null;
  postcode: string | null = null;
  city: string | null = null;
  date: string | null = null;
  time: string | null = null;

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport().incidentAddress) {
        const incidentAddress = this.claimService.claimReport().incidentAddress;
        this.street = incidentAddress?.street;
        this.houseNumber = incidentAddress?.houseNumber;
        this.postcode = incidentAddress?.postcode;
        this.city = incidentAddress?.city;
      }
      const storedDate = this.claimService?.claimReport()?.incidentDate;

      this.date = storedDate ? format(storedDate, 'yyyy-MM-dd') : null;
      this.time = storedDate ? format(storedDate, 'HH:mm') : null;

    })
  }

  private evaluateShowError() {
    this.showError = this.street === null
      || this.street?.length === 0
      || this.houseNumber === null
      || this.houseNumber?.length === 0
      || this.postcode === null
      || this.postcode?.length === 0
      || this.city === null
      || this.city?.length === 0
      || this.date === null
      || this.date?.length === 0
      || this.time === null
      || this.time?.length === 0;
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError && this.date && this.time) {
      const [hours, minutes] = this.time.split(':').map(Number);
      this.claimService.updateClaimReport({
        incidentAddress: {
          street: this.street,
          houseNumber: this.houseNumber,
          postcode: this.postcode,
          city: this.city
        },
        incidentDate: set(parseISO(this.date), {hours, minutes, seconds: 0, milliseconds: 0})
      })
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['accident-location']);
      });
    }
  }
}
